import React, {useState} from 'react';
import BuyNowProductPopUp from 'Shared/BuyNowProductPopUp';
import BuyUSPopUp from 'Shared/BuyUSPopUp';
import PopupNioxin from 'Shared/PopupNioxin';
import { BVRatingButton } from "BVRating/BVRatingButton/BVRatingButton";

const Description = (props) => {
    const {
        Title,
        Subtitle,
        Description,
        ProductPopup,
        SocialShareCopyTextFacbook,
        SocialShareCopyTextPinttrest,
        SocialShareCopyTextTwitter,
        FacebookLink,
        PinterestLink,
        BuyNowPopup,
        BuyNowText,
        YotpoProductId,
        BuyNowButtonText,
        BuyNowButtonUrl,
    } = props.product.Model;

    const lang = document.getElementById("divlang").getAttribute("data-id");

    const [productPopupVisible, setProductPopupVisible] = useState(false);
    const [nioxinPopupVisible, setNioxinPopupVisible] = useState(false);

    const showPopUp = (event, type) => {
        event.preventDefault();
        if (type === "product") {
            setProductPopupVisible(true);
        } else if (type === "nioxin") {
            setNioxinPopupVisible(true);
        }
        checkKey();
    }
    const hidePopUp = (event, type) => {
        event.preventDefault();
        if (type === "product") {
            setProductPopupVisible(false);
        } else if (type === "nioxin") {
            setNioxinPopupVisible(false);
        }
    }
    const checkKey = () => {
        document.addEventListener("keyup", function (e) {
            if (e.keyCode == 27) {
                setProductPopupVisible(false);
                setNioxinPopupVisible(false);
                document.removeEventListener("keyup", null)
            }
        })
    }
    return (
        <div className="product-description">
            <h1 className="product-title" dangerouslySetInnerHTML={{"__html": Title.Value }} />
            {Subtitle.Value !== "" && (
                <h2 className="product-subtitle" dangerouslySetInnerHTML={{"__html": Subtitle.Value }} />
            )}

            {YotpoProductId && (
                <div className="yotpo bottomLine" data-yotpo-product-id={YotpoProductId} />
            )}
            <div>
                <div className="bv-rating" data-bv-show="rating_summary" data-bv-product-id={props.bvId}></div>
                <BVRatingButton link />
            </div>
            {ProductPopup.length > 0 ? (
                <a id="shop-now" href="" onClick={(event) => showPopUp(event, "product")} className="buy-now-button" data-test="buynow-button">
                    <span>{ProductPopup[0].BuyNowButtonText && ProductPopup[0].BuyNowButtonText.Value !== "" ? ProductPopup[0].BuyNowButtonText.Value : "BUY NOW"}</span>
                </a>
                ) : BuyNowPopup.length > 0 ? (
                <a href="" onClick={(event) => showPopUp(event, "nioxin")} className="buy-now-button" data-test="buynow-button">
                    <span>{BuyNowText.Value}</span>
                </a>
                ) : BuyNowButtonText.Value !== "" && (
                <a href={BuyNowButtonUrl.Value} className="buy-now-button" data-test="buynow-button" target='_blank'>
                    <span>{BuyNowButtonText.Value}</span>
                </a>
            )}
            {productPopupVisible && (
                lang === "en-US" ? (
                    <BuyUSPopUp
                        productHidePopUp={hidePopUp}
                        productPopup={productPopupVisible}
                        Product={ProductPopup[0]}
                    />
                ) : (
                    <BuyNowProductPopUp
                        productHidePopUp={hidePopUp}
                        productPopup={productPopupVisible}
                        Product={ProductPopup[0]}
                        SocialShareCopyTextFacbook={SocialShareCopyTextFacbook}
                        SocialShareCopyTextPinttrest={SocialShareCopyTextPinttrest}
                        SocialShareCopyTextTwitter={SocialShareCopyTextTwitter}
                        FacebookLink={FacebookLink}
                        PinterestLink={PinterestLink}
                        isDesktop={props.isDesktop}
                     />
                )
            )}
            {nioxinPopupVisible ? (
                <PopupNioxin
                    hidePopUp={hidePopUp}
                    popup={nioxinPopupVisible}
                    pushesPopup={BuyNowPopup}
                />
            ) : null}

            <div className="description-text" dangerouslySetInnerHTML={{"__html": Description.Value}} />
        </div>
    );
}
export default Description;
